import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-nav-panel-contrato',
  templateUrl: './nav-panel-contrato.component.html',
  styleUrls: ['./nav-panel-contrato.component.css']
})
export class NavPanelContratoComponent implements OnInit {

  @Input() idContrato!: number
  constructor(
    private aRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const routeParams = this.aRoute.snapshot.paramMap;
    this.idContrato = Number(routeParams.get('id'));
  }

}
